function showVideo(videoWrapperSelector) {
    const videoWrappers = document.querySelectorAll(videoWrapperSelector);
        videoWrappers.forEach(videoWrapper => {
            const videoSrc = videoWrapper.getAttribute('data-src');
            videoWrapper.addEventListener('click', () => {
                videoWrapper.innerHTML = 
                `<iframe src=${videoSrc}
                    width="853" height="480"
                    style="background-color: #000"
                    allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
                    frameborder="0"
                    allowfullscreen>
                </iframe>`
                // `<iframe src=${videoSrc} width="1280" height="720" encrypted-media; picture-in-picture; screen-wake-lock;" frameborder="0"></iframe>`;
            }, { once: true });
        })
}

export default showVideo;